export default "__VITE_ASSET__CHdvnWOm__"